import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loading, Empty } from "@/components/common";

export default function Performance() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = async () => { try { const { data: response } = await api.get("/performance/summary"); setData(response); } finally { setLoading(false); } };
  useEffect(() => { load(); const timer = window.setInterval(load, 30000); return () => window.clearInterval(timer); }, []);
  if (loading) return <Loading />;
  const staff = data?.staff || [];

  return (
    <div>
      <PageHeader title="Kinerja Karyawan" subtitle="Fokus kedisiplinan kehadiran 30 hari terakhir" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {staff.length === 0 && <Empty />}
        {staff.map((person, index) => (
          <div key={person.staff_id} className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 performance-card" data-testid={`perf-${person.staff_id}`} style={{ animationDelay: `${index * 70}ms` }}>
            <div className="flex items-center justify-between mb-4"><div><div className="font-semibold text-slate-800">{person.name}</div><div className="text-xs uppercase text-sky-600 font-semibold">{person.role}</div></div><div className="w-11 h-11 rounded-2xl bg-sky-50 text-sky-700 flex items-center justify-center font-mono-num font-semibold">{person.attendance_days || 0}</div></div>
            <div className="space-y-2 text-sm"><Row label="Hari Hadir" value={`${person.attendance_days || 0} hari`} /><Row label="Hari Libur / Alpa" value={`${person.attendance_absent_days || 0} hari`} tone="text-amber-600" /><Row label="Total Terlambat" value={`${person.late_minutes || 0} menit`} tone="text-red-600" /><Row label="Total Lembur" value={`${person.overtime_minutes || 0} menit`} tone="text-green-600" /></div>
          </div>
        ))}
      </div>
    </div>
  );
}

const Row = ({ label, value, tone = "text-slate-700" }) => <div className="flex justify-between"><span className="text-slate-500">{label}</span><span className={`font-mono-num ${tone}`}>{value}</span></div>;
